module.exports = __webpack_public_path__ + "static/media/alice.87f63ce6.jpg";